import { MissingEventError } from "@@/shared/errors/missing-event.error";
import type { OrderEvent } from "../order-events/events/_order-event";
import type { OrderId } from "../order-id";

const missingOrderEventCheck = (
    orderId: OrderId,
    events: OrderEvent[],
    options?: {
        startAtVersion?: number;
    },
) => {
    const startAtVersion = options?.startAtVersion ?? 0;
    const erroneousVersions = events
        .map((event, index) => {
            const expectedVersion = index + startAtVersion;
            if (event._version !== expectedVersion) {
                return expectedVersion;
            }
            return undefined;
        })
        .filter(version => typeof version !== "undefined");
    if (erroneousVersions?.length) {
        throw new MissingEventError(
            `Missing event with version number: ${
                erroneousVersions[0]
            }, either there are gaps between the events, or the events are not in a sequential order; orderId: ${orderId}, Versions: ${events
                .map(event => event._version)
                .join(", ")}`,
            erroneousVersions[0],
        );
    }
};

export { missingOrderEventCheck };
